/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import QuestionPage from './QuestionPage'
import { withStyles } from '@material-ui/core/styles/index'
import { styles } from './QuestionPageWrapper.styles'
import QuestionPageNavigation from './partials/QuestionPageNavigation'
import { LinearProgress } from '@material-ui/core'
import SignupView from './SignupView'

class QuestionPageWrapper extends PureComponent {
    render() {
        const {
            classes,
            questionPage,
            pageAlias,
            isLoading,
            activeStep,
            onNext,
            childNext,
            childPrev,
            questionPageRef,
            visitorSessionId,
            theme
        } = this.props

        return (
            <>
                {questionPage && questionPage.id && (
                    <>
                        {questionPage.signupProcessType ? (
                            <SignupView questionPage={questionPage} onComplete={onNext} theme={theme} visitorSessionId={visitorSessionId} />
                        ) : (
                            <QuestionPage
                                questionPage={questionPage}
                                onSubmit={onNext}
                                innerRef={questionPageRef}
                                alias={pageAlias}
                                isLoading={isLoading}
                                visitorSessionId={visitorSessionId}
                                theme={theme}
                            />
                        )}
                    </>
                )}
                {questionPage && questionPage.showNavigation && (
                    <QuestionPageNavigation
                        questionPage={questionPage}
                        isLoading={isLoading}
                        next={childNext}
                        prev={childPrev}
                        activeStep={activeStep}
                    />
                )}
                {isLoading && questionPage.showLoadingBar && (
                    <LinearProgress className={classes.loader} classes={{ root: classes.progressBarRoot, bar: classes.progressBarBar }} />
                )}
            </>
        )
    }
}

export default withStyles(styles)(QuestionPageWrapper)
